import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as dashboard from './DashboardRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({dashboard: state.dashboard})
const connector = connect(mapState, dashboard.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const DashboardInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(DashboardInit)
